import React, { useState } from 'react';
import Icon from '../common/Icon';

const KnowledgeBase = () => {
    const [files, setFiles] = useState([]);

    const handleFileChange = (e) => {
        if (e.target.files) {
            setFiles(prev => [...prev, ...Array.from(e.target.files)]);
        }
    };

    return (
        <div>
            <h1 className="text-3xl font-bold text-gray-800 mb-6">Knowledge Base</h1>
            <div className="bg-white p-8 rounded-lg shadow-lg">
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Upload Documents</h2>
                <p className="text-gray-500 mb-6">Upload documents (PDF, DOCX, TXT) to create a knowledge base for your AI agents. This allows them to answer questions based on the provided information.</p>
                
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                    <Icon path="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z" className="mx-auto h-12 w-12 text-gray-400" />
                    <label htmlFor="file-upload" className="mt-4 relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-[#7B34BB] focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                        <span>Upload a file</span>
                        <input id="file-upload" name="file-upload" type="file" className="sr-only" multiple onChange={handleFileChange} accept=".pdf,.docx,.txt" />
                    </label>
                    <p className="text-xs text-gray-500 mt-1">PDF, DOCX, TXT up to 10MB</p>
                </div>

                {files.length > 0 && (
                    <div className="mt-8">
                        <h3 className="font-semibold text-gray-700">Uploaded Files:</h3>
                        <ul className="mt-2 space-y-2">
                            {files.map((file, index) => (
                                <li key={index} className="flex justify-between items-center bg-gray-50 p-3 rounded-md">
                                    <span className="text-sm text-gray-800">{file.name}</span>
                                    <span className="text-xs text-gray-500">{(file.size / 1024).toFixed(2)} KB</span>
                                </li>
                            ))}
                        </ul>
                         <button className="mt-4 w-full bg-[#B67BF4] text-white py-2 rounded-lg hover:bg-[#7B34BB]">Link to Agent</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default KnowledgeBase;

